import { render, staticRenderFns } from "./DetailedPaymentList.vue?vue&type=template&id=89b4ca42&"
import script from "./DetailedPaymentList.vue?vue&type=script&lang=js&"
export * from "./DetailedPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports